import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { getDollarPrice } from '../../../../helpers/general';
import { formatPrice, formatTransactionDate } from '../../../../helpers/formatData';
import Close from '../../../common/ui/Close';

export default class Transactions extends Component {
  static propTypes = {
    transactions: PropTypes.array
  };

  state = {
    modalIsOpen: false
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  _renderTransaction = transaction => {
    const { id, transaction_type, amount, failed_timestamp, dc, failed_reason } = transaction;
    const date = formatTransactionDate(failed_timestamp || dc);
    const transactionAmount = formatPrice(getDollarPrice(amount));
    return (
      <div key={id} className={`transaction-row row flex-wrap ${failed_timestamp ? 'failed' : ''}`}>
        <div className='text-capitalize col-4'>{transaction_type.replace('_', ' ')}</div>
        <div className='col-4 text-center'>{date}</div>
        <div className='col-4 text-right'>
          { transaction_type === 'credit' ? `(${transactionAmount})` : transactionAmount }
        </div>
        { failed_reason && <div className='failed-reason'>{failed_reason}</div> }
      </div>
    );
  };

  render () {
    const { modalIsOpen } = this.state;
    const { transactions } = this.props;
    return (
      <div>
        { transactions && (
          <button
            className='section-row non-button transaction-link'
            onClick={this.openModal}
          >
            Payment transactions
          </button>
        )}
        <Modal isOpen={modalIsOpen} centered>
          <div className='modal-header'>
            <div className='modal-title'>Transaction History</div>
            <Close onClick={this.closeModal} />
          </div>
          <div className='modal-body'>
            { transactions && transactions.map(this._renderTransaction)}
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/JobDetailsTab/Transactions.js